import { render, staticRenderFns } from "./EmployeeDniExpirationDateField.vue?vue&type=template&id=caf13db0&"
import script from "./EmployeeDniExpirationDateField.vue?vue&type=script&lang=js&"
export * from "./EmployeeDniExpirationDateField.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/vsts/work/1/s/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('caf13db0')) {
      api.createRecord('caf13db0', component.options)
    } else {
      api.reload('caf13db0', component.options)
    }
    module.hot.accept("./EmployeeDniExpirationDateField.vue?vue&type=template&id=caf13db0&", function () {
      api.rerender('caf13db0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/profile/fields/EmployeeDniExpirationDateField.vue"
export default component.exports